import { Inject, Injectable } from "@angular/core";
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwOrmDataService, DwOrmDataServiceToken, DwQuery, DwUserEntity } from "@devwareapps/devware-cap";
import { AcsTestEntity, AppMetaData, AppMetaDataItemNames, CheckRideRequestEntity, FlightSchoolApplicantEntity, PilotExaminerEntity, PlanOfActionEntity } from "../../../meta-data/app-meta-data.service";

@DwCustomContextDefinition({
    keyName: 'planofaction-current-context',
    display: 'Plan Of Action Current Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.PlanOfAction,
})
@Injectable()
export class PlanOfActionCurrentContextService extends DwCustomContextBase {

     constructor(
            @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        ) {
            super();
        }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext, contextData) => {
            const planOfAction: PlanOfActionEntity = resolvedContext.data;

            return planOfAction;
        };

        contextDef.item = AppMetaDataItemNames.CheckRideRequest;
        contextDef.useItemMetaData = true;
    } 
} 